import { Tag } from "~/common/components";
import { isSessionTranscriptAvailable } from "~/providers/utils/sessionTranscriptStatus";
import { ZoomMeeting } from "~/providers/utils/types/zoomMeetingTypes";

interface SessionDocumentationTagsProps {
  session: ZoomMeeting;
}

const documentationTagClassName = "bg-primary-200 text-primary-800 text-xs";

export const SessionDocumentationTags = ({
  session,
}: SessionDocumentationTagsProps) => {
  const tags = [
    isSessionTranscriptAvailable(session.transcript_status) && {
      key: "transcript",
      label: "Transcript",
    },
    session.has_signed_soap_note && {
      key: "soap-note",
      label: "SOAP note",
    },
    session.has_signed_billing_note && {
      key: "billing-note",
      label: "Billing note",
    },
  ].filter(Boolean) as {
    key: string;
    label: string;
  }[];

  if (!tags.length) {
    return "-";
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <Tag key={tag.key} className={documentationTagClassName}>
          <p>{tag.label}</p>
        </Tag>
      ))}
    </div>
  );
};
